import React from 'react';
import {

    PanelHeader,

    List,
    Cell,
    PanelHeaderButton,
    Div,

    SplitCol,
    SplitLayout,

    Button, Spinner, Pagination, Search
} from '@vkontakte/vkui';

import moment from "moment";

import {
    Icon20AddCircleFillGreen,
    Icon24Refresh,
    Icon24Search
} from "@vkontakte/icons";
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';

import {AdaptivityContext, sale_point_monitoring_date_period_key} from "../assets/constants";
import BaseComponent from "./BaseComponent";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import {addDays} from "@vkontakte/vkui/dist/lib/date";
import HelpButton from "../assets/HelpButton";


class BaseList extends BaseComponent {


    constructor(props) {


        super(props);
        
        // Загружаем сохраненный период из localStorage или используем значения по умолчанию
        const getDefaultDateValue = () => {
            try {
                const savedPeriod = localStorage.getItem(sale_point_monitoring_date_period_key);
                if (savedPeriod) {
                    const parsed = JSON.parse(savedPeriod);
                    return [new Date(parsed[0]), new Date(parsed[1])];
                }
            } catch (error) {
                console.warn('Ошибка при загрузке периода из localStorage:', error);
            }
            return [addDays(new Date(), -10), new Date()];
        };
        
        const state = {
            items: [],
            cnt_items: 0,
            loading: true,
            currentItemId: null,
            append: false,
            page: 1,
            totalPages: 1,
            mainSearch: '',
            showSearch: false,
            currentPopout: null,
            dateRangeIsOpen: false,
            lastOpenedItemId: null, // ID последнего просмотренного/редактируемого элемента

            dateValue: getDefaultDateValue(),
        }
        this.state = {
            ...this.state,
            ...state
        }

        // Восстанавливаем состояние из родителя если оно было сохранено
        if (props && props.savedListState) {
            this.state = {
                ...this.state,
                ...props.savedListState
            }
        }
    }

    /**
     * Метод для получения дополнительных полей состояния для сохранения.
     * Дочерние классы могут переопределить для добавления своих специфичных полей.
     * @returns {Object} объект с дополнительными полями состояния
     */
    getAdditionalStateToSave() {
        return {};
    }

    /**
     * Возвращает стиль для строки с выделением последнего открытого элемента
     * @param {Object} item - элемент списка
     * @param {Object} additionalStyle - дополнительные стили (например backgroundColor)
     * @returns {Object} объект стилей
     */
    getRowStyle(item, additionalStyle = {}) {
        const isLastOpened = this.state.lastOpenedItemId && item.id === this.state.lastOpenedItemId;
        return {
            ...additionalStyle,
            ...(isLastOpened ? { 
                border: '2px solid orange',
                borderRadius: '8px'
            } : {})
        };
    }

    /**
     * Устанавливает ID последнего открытого элемента
     * @param {number|string} itemId - ID элемента
     */
    setLastOpenedItem(itemId) {
        this.setState({ lastOpenedItemId: itemId });
    }

    setCurrentPopout(currentPopout) {
        this.setCurrentPopout({currentPopout})
    }

    getItems = (mainSearch = '', append = false, page = 1) => {


    }


    checkScroll = () => {
        if (AdaptivityContext.isMobile) {
            let headerMobStorage = document.getElementsByClassName('mobile-table-storage-header')

            if (!headerMobStorage || headerMobStorage.length === 0) return

            headerMobStorage = headerMobStorage[0]
            const scrolled = window.scrollY

            if (scrolled > 100 && scrolled > this.scrollPrev) {
                headerMobStorage.classList.add('out')
            } else {
                headerMobStorage.classList.remove('out')
            }
            this.scrollPrev = scrolled
        }

        if (!this.ref.current) return
        if (this.state.cnt_items * 1 <= this.state.items.length) return
        let visible = this.ref.current.getBoundingClientRect().top < window.innerHeight - 50;

        if (!this.state.loading && visible) {
            let page = this.state.page
            if (page >= this.state.totalPages * 1) return
            page++;
            this.setState({page: page})

            this.getItems('', true, page)


        }
    }

    handleScroll() {
        this.checkScroll()
    }

    receiveMessage = (event) => {

        if (event.data.type) {
            if (event.data.type == 'reloadCurrentList') {
                this.doRefresh()
            }
        }
    }
    componentDidMount = () => {
        super.componentDidMount()
        moment.locale('ru')
        
        // Если есть сохранённое состояние с данными - не загружаем заново
        if (this.props.savedListState && this.props.savedListState.items && this.props.savedListState.items.length > 0) {
            return;
        }
        
        this.getItems()
    }

    componentWillUnmount() {
        // Сохраняем состояние в родительский компонент перед размонтированием
        if (this.props.onSaveListState) {
            const stateToSave = {
                items: this.state.items,
                cnt_items: this.state.cnt_items,
                page: this.state.page,
                totalPages: this.state.totalPages,
                mainSearch: this.state.mainSearch,
                showSearch: this.state.showSearch,
                lastOpenedItemId: this.state.lastOpenedItemId,
                loading: false, // При восстановлении не показываем спиннер
                ...this.getAdditionalStateToSave()
            };
            this.props.onSaveListState(stateToSave);
        }
        
        super.componentWillUnmount();
    }

    setPage = (page) => {
        if (page <= this.state.totalPages) {
            this.setState({loading: true, page: page})
            setTimeout(() =>
                this.getItems(this.state.mainSearch, false, page), 600)
        }
    }

    toggleSearch = () => {


        this.setState({showSearch: !this.state.showSearch});

    }

    searchInterval = null;
    element = null;
    onSearchChange = (state) => {


        clearInterval(this.searchInterval);
        this.setState({mainSearch: state.target.value});
        this.searchInterval = setInterval(() => {
            // console.log(state);
            this.setState({loading: true, page: 1});
            this.getItems(this.state.mainSearch, false, 1);
        }, state.target.value == '' ? 500 : 2000);

    }

    getItem = (item) => {

    }

    /**
     * Для диплинка / контекстного меню: вернуть { type, id } или null.
     * Переопределяется в списках справочников.
     */
    getObjectLink(item) {
        return null;
    }

    handleRowContextMenu = (e, item) => {
        if (AdaptivityContext.isMobile) {
            return;
        }
        const link = this.getObjectLink(item);
        if (!link || link.id == null || link.id === '' || Number(link.id) <= 0) {
            return;
        }
        e.preventDefault();
        window.postMessage({
            type: 'showObjectContextMenu',
            x: e.clientX,
            y: e.clientY,
            objectType: link.type,
            objectId: link.id,
        });
    }

    renderToolbar = () => {
        return <div
            className={AdaptivityContext.isMobile || true ? 'mobile-table-storage-header' : 'desktop-table-storage-header'}>
            <SplitLayout>
                <SplitCol style={{justifyContent: "flex-start"}}>
                    <Div>
                        {this.canCreateItem() && <Button mode="outline" disabled={this.state.isOffline}
                                                         onClick={() => this.createItem()}><Icon20AddCircleFillGreen/></Button>}
                    </Div>
                </SplitCol>
                <SplitCol>
                    <Div style={{display: 'flex', flexDirection: 'column'}}>
                        <span className="all-docs"
                              id="cnt_items">Всего элементов: {this.state.cnt_items}</span>
                        {this.state.isOffline && <span className="all-docs"
                                                       id="is_offline">Offline  режим<HelpButton text={"Нет связи с интернет. Работаем в автономном режиме"} /></span>
                        }


                    </Div>
                </SplitCol>
            </SplitLayout>
        </div>
    }
    renderRow = (item, index) => {
        return null
    }

    doRefresh = () => {
        this.setState({page: 1, items: []});
        this.getItems(this.state.mainSearch, false, 1)
    }
    dateChange = (e) => {

        this.setState({dateRangeIsOpen: false, loading: true, dateValue: e, page: 1, items: []})
        
        // Сохраняем период в localStorage
        try {
            const periodToSave = [e[0].toISOString(), e[1].toISOString()];
            localStorage.setItem(sale_point_monitoring_date_period_key, JSON.stringify(periodToSave));
        } catch (error) {
            console.warn('Ошибка при сохранении периода в localStorage:', error);
        }

        setTimeout(() =>
            this.getItems(), 700)
    }

    render() {

        return (
            <SplitLayout popout={this.state.currentPopout}>
                <SplitCol>
                    <PanelHeader fixed={true}
                                 before={AdaptivityContext.isMobile && !this.props.parent_product_id ?
                                     <PanelHeaderButton style={{display: 'inline'}}
                                                        onClick={this.toggleSearch}><Icon24Search/></PanelHeaderButton> : ''}
                                 after={!this.state.showSearch || !AdaptivityContext.isMobile ?
                                     <Div style={{display: "flex"}}>
                                         {this.props.date_range && <DateRangePicker
                                             onCalendarClose={() => setTimeout(() => this.setState({dateRangeIsOpen: false}), 1000)}
                                             onClick={() => {
                                                 this.setState({dateRangeIsOpen: true});

                                             }}
                                             showLeadingZeros={true}
                                             value={this.state.dateValue}
                                             isOpen={this.state.dateRangeIsOpen}
                                             key="SaleDocsDateRangePicker"
                                             onChange={this.dateChange}/>}
                                         <Button size="s" mode="tertiary" style={{maxWidth: "42px"}}
                                                 onClick={() => this.doRefresh()}><Icon24Refresh/></Button>
                                     </Div> : ''}

                    >
                        {(this.state.showSearch || !AdaptivityContext.isMobile) ? (
                            <Div>
                                <form onSubmit={e => {
                                    e.preventDefault();
                                    e.stopPropagation()
                                }}>
                                    <Search autoFocus
                                            autocomplete="off"
                                            theme="header"
                                            placeholder="Поиск"
                                            value={this.state.mainSearch}
                                            onChange={this.onSearchChange}
                                            onClose={this.toggleSearch}
                                            style={{flexGrow: '1', maxWidth: '350px'}}
                                    />
                                </form>
                            </Div>
                        ) : null}
                    </PanelHeader>
                    {this.renderToolbar()}
                    {!this.state.loading && Array.isArray(this.state.items)
                        && this.state.items.length === 0 && <Cell key={'notFound' + 0}>Ничего не найдено</Cell>}
                    {this.state.items.map((item, index) => {
                        const rowKey = item && item.id != null ? `row-${item.id}` : `row-idx-${index}`;
                        const ctxProps = !AdaptivityContext.isMobile
                            ? {onContextMenu: (e) => this.handleRowContextMenu(e, item)}
                            : {};
                        return (
                            <React.Fragment key={rowKey}>
                                <div style={{width: '100%'}} {...ctxProps}>
                                    <SplitLayout>

                                        <SplitCol width={110}>
                                            <List>
                                                {this.renderRow(item, index)}

                                            </List>
                                        </SplitCol>
                                    </SplitLayout>
                                </div>

                                <hr/>
                            </React.Fragment>
                        );
                    })}
                    {AdaptivityContext.isMobile || true ?
                        <div ref={this.ref} key="loader" style={{height: '50px', width: 'auto'}}>{this.state.loading ?
                            <Cell before="Запрашиваем данные с сервера"
                                  after={<Spinner size="large"/>}></Cell> : ""}</div> : this.state.loading ?
                            <Cell before="Запрашиваем данные с сервера" after={<Spinner size="large"/>}></Cell> : ""}
                    {this.state.totalPages > 1 && !AdaptivityContext.isMobile ?
                        <div style={{background: "whitesmoke", position: "fixed", bottom: "52px", zIndex: '99'}}>
                            <Pagination currentPage={this.state.page}
                                        totalPages={this.state.totalPages}
                                        onChange={this.setPage}/>
                        </div> : ''}
                </SplitCol>
            </SplitLayout>
        )
    }

    createItem = () => {

    }

    canCreateItem() {
        return true
    }
}

export default BaseList